import { render, staticRenderFns } from "./Scanner.vue?vue&type=template&id=5b35ba7c&scoped=true&"
import script from "./Scanner.vue?vue&type=script&lang=js&"
export * from "./Scanner.vue?vue&type=script&lang=js&"
import style0 from "./Scanner.vue?vue&type=style&index=0&id=5b35ba7c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b35ba7c",
  null
  
)

export default component.exports